import { FieldTypes } from '../../FieldTypes';
import { ResponseFieldDataSourceType } from '../../services/page-meta.service';
import { DialogFields } from '../../services/vias-dialog.service';
import { ButtonBarItem } from '../buttonbar/buttonbar.component';
import { DataGridColumn, DGButtons, StatusBarSummaryData } from '../datagrid/datagrid.component';

export interface ServiceCall {
  pid: number;
  aid: number;
  data: string;
  returnField: string;
  value?: any;
  initData?: any;
  // donen deger baska alanin icine yazilacak
  otherFieldVal?: string;
  // donene deger baska alana select option lari olacak
  otherFieldDataSource?: string;
  // güncelleme modunda çalışsın mı?
  serviceWorkStatusEditMode?: boolean;
  isContractor?: boolean;
}
export interface FormEvent {
  payload: object;
}
export interface FormOption {
  data: string;
  label: string;
  checkId?: string;
}
export interface FormSubmitFields{
  postFieldName: string;

  responseFieldId?: string;
  responseFieldName?: string;
  responseFieldType?: ResponseFieldDataSourceType;

  value?: string;
}

export interface TabItem {
  label: string;
  disabled?: boolean;
  icon?: string;
  disabledFunc?: (...$args) => boolean;
}

export interface FormItem {
  type: FieldTypes;
  // alanin idsi
  name: string;
  // alanin gelen idsi
  id?: string;
  // gozuken ismi (translate edilecek text)
  label?: string;
  // alanin  degeri yada secili degerin idsi
  value?: any;
  // zorunlu alanlar icin secilecek
  required?: boolean;
  disabled?: boolean;
  appearance?:string;
  //outline ozelligini kullandigimizda mat prefix ile ust uste gelmesin diye bunu always gondermemiz gerek
  floatLabel?:string;
  disabledOnInspect?: boolean;
  // form validators
  validations?: FormValidator[];
  // TL , GUN gibi saginda yazsinmi
  matSuffix?: boolean;
  // ne yazsin
  matSuffixText?: string;
  // $ % gibi solunda yazsinmi
  matPrefix?: boolean;
  // solunda ne yazsin
  matPrefixText?: string;
  inputWidthPercent?: number;
  // onchange service call
  // onchange service pid, aid etc
  onChangedServiceCall?: ServiceCall[];

  // onchange method call
  // degisiklik oldugunda calisacak method
  onChangedFunc?: (...$args) => void;
  // secim oldugunda calisacak method
  onSelectedFunc?: (selectedId: number) => void;

  // farklı bir data dan geliyor ise bu kullanılacak
  dataSource?: string;
  // sadece formitem.ts iceride kullanilacak
  options?: FormOption[];
  // db den gelen alanin adi YA BU OLACAK
  optionsFieldName?: string;
  // db den gelen data source iceride options a yazilacak
  // YADA BUNLAR OLCAK
  optionsDataSource?: object[];
  // el ile yazilan data source yada status var fln fln
  optionsDataSourceFunc?: () => FormOption[];
  // dbden gelen yada elle yazdigimiz alanin id alanina denk gelen isim
  optionsDataIdField?: string;
  // dbden gelen yada elle yazdigimiz alanin label alanina denk gelen isim
  optionsDataLabelField?: string;

  // eger table type ise datagrid sutun bilgisi
  tableColumns?: DataGridColumn[];
  tableDataSource?: object[];
  tableOptions?: {};
  tableDGButtons?: DGButtons;
  tableStatusBarItems?: StatusBarSummaryData[];
  // table button bar
  hasTableButtonbar?: boolean;
  hasMultiSelectTable?: boolean;
  tableButtonBarItems?: ButtonBarItem[];
  tableButtonBarData?: any;
  tableRefresh?: ($event) => void;
  tableChange?: ($event) => void;
  tableCellChange?: ($event) => void;
  tableClick?: ($event) => void;
  tableDblClick?: ($event) => void;
  tableSelectChange?: ($event) => void;
  tableEditClick?: ($event) => void;
  tableAddClick?: ($event) => void;
  tableDeleteClick?: ($event) => void;
  tableAddDialogFields?: DialogFields;
  tableEditDialogFields?: DialogFields;
  tableDeleteDialogFields?: DialogFields;

  // eger tab var ise hangi taba ait oldugu
  tabIndex?: number;

  // component genisligi
  // undefined/0/1 = 100%, 2= 50%, 3=33%
  componentFixedWidth?: number;
  // input yanına buton eklemek için
  icon?: boolean;
  icon_type?: string;
  iconClick?: (...$args) => void;

  width?: string; // ie. '100%' '80vw'
  height?: string;
  maxlength?: number;
  multiline?: boolean;
  // Button colors
  color?: string;
  // form icinde ki diger form itemlar valuelarini buradan alicak
  // orn. depo fisindeki 3 birimli giris
  // bu degistirecek olan (master) alana
  connectedValuesFormItems?: string[];
  // bu kisim degisecek olan (slave) alanlara
  connectedValueSetFunction?: ($data) => any;

  // checkbox ve dropdown da bagli alanlari toggle
  toggleFormItems?: string[];
  // dropbox icin asagidaki veriler gelince kapat
  toggleOffValues?: FormOption[];

  // page viewer icin
  htmlContent?: string;
  contentComponent?: string;
}
export interface FormValidator {
  name: string;
  validator: any;
  message: string;
}

export class TextboxFormItem implements FormItem {
  type = FieldTypes.Input;
  name;
  label?;
  validations?;
  inputType;

  public constructor(init?: Partial<DropdownFormItem>) {
    Object.assign(this, init);
  }
}

export class ButtonFormItem implements FormItem {
  type = FieldTypes.Input;
  name;
  label?;
  validations?;
  buttonColor;
  buttonType;

  public constructor(init?: Partial<DropdownFormItem>) {
    Object.assign(this, init);
  }
}

export class DropdownFormItem implements FormItem {
  type = FieldTypes.DropDown;
  name;
  label?;
  validations?;
  options?: FormOption[];
  /**
   * eger options belli degil ise,
   * bu method base de cagrilacak.
   * Bu sadece init olurken calisacak.
   */
  optionInitFunction?: string;

  public constructor(init?: Partial<DropdownFormItem>) {
    Object.assign(this, init);
  }
}

export class AutoCompleteFormItem implements FormItem {
  type = FieldTypes.AutoComplete;
  name;
  label?;
  validations?;
  options?: FormOption[] = [];
  /**
   * eger options belli degil ise,
   * bu method base de cagrilacak.
   * Bu sadece init olurken calisacak.
   */
  optionInitFunction?: string;

  public constructor(init?: Partial<AutoCompleteFormItem>) {
    Object.assign(this, init);
  }
}
